import React, { useState } from "react";

const getStatusClass = (status) =>
  status === "Submitted"
    ? "submitted"
    : status === "Submittal Approved"
      ? "approved"
      : status === "Lost"
        ? "lost"
        : status === "Under Preparation"
          ? "preparation"
          : "neutral";

const getStatusOptions = (item, quotationStatus) =>
  (quotationStatus || [])
    .filter(
      (status) =>
        status?.statusDesc !== "Cancelled" &&
        status?.statusDesc !== "Order Received" &&
        (status?.id === item?.quoteStatusId || status?.id > item?.quoteStatusId)
    )
    .sort((a, b) => a?.id - b?.id);

const QuotationStatusCell = ({
  item,
  quotationStatus,
  handleStatusOpen,
  handleQuotationStatusUpdate,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const statusClass = getStatusClass(item?.quoteStatus);
  const statusOptions = getStatusOptions(item, quotationStatus);

  const handleStatusChange = (event) => {
    const newStatusId = Number(event.target.value);
    if (!newStatusId || newStatusId === item?.quoteStatusId) {
      setIsEditing(false);
      return;
    }

    const statusOption = quotationStatus?.find((status) => status?.id === newStatusId);
    setIsEditing(false);

    if (statusOption?.statusDesc === "Lost") {
      handleStatusOpen(item, statusOption);
      return;
    }

    handleQuotationStatusUpdate?.(
      {
        quotationId: item?.id,
        newStatusId,
        lostReasonId: 0,
        lostTo: "",
        lostDetails: "",
        lostPrice: 0,
      },
      statusOption
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <select
        autoFocus
        id={`quotation-status-${item?.id}`}
        name={`quotationStatus-${item?.id}`}
        className={`quote-status-select ${statusClass}`}
        value={item?.quoteStatusId || ""}
        onChange={handleStatusChange}
        onBlur={() => setIsEditing(false)}
        onKeyDown={handleKeyDown}
        title={item?.quoteStatus || "Update status"}
        aria-label={`Update status for ${item?.quoteReference}`}
      >
        {statusOptions.length === 0 && (
          <option value={item?.quoteStatusId || ""}>
            {item?.quoteStatus || "Status"}
          </option>
        )}
        {statusOptions.map((status) => (
          <option key={status?.id} value={status?.id}>
            {status?.statusDesc}
          </option>
        ))}
      </select>
    );
  }

  return (
    <button
      className={`quote-status-pill ${statusClass}`}
      type="button"
      onClick={() => setIsEditing(true)}
      title={`Change status: ${item?.quoteStatus || "Status"}`}
      aria-label={`Change status for ${item?.quoteReference}`}
    >
      <span>{item?.quoteStatus || "Status"}</span>
    </button>
  );
};

export default React.memo(QuotationStatusCell);
